<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-account-multiple-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">Add Location</span>
      <span v-else>Edit Location </span>
    </h1>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col sm="6" cols="12" class="align-self-center">
            <h4 class="mb-2">Upload Location Logo</h4>
            <section class="file-upload">
              <new-image-upload
                class="file-upload__image"
                :imgUrl="form.logo ? form.logo.path : ''"
                :imgId="form.logo ? form.logo.id : ''"
                @fileSelected="profileChange"
                fieldName="mainImgFile"
                :maxSize="maxSize"
                :reset="resetBoolean"
              />
              <template v-if="form.logo != null">
                <a
                  :href="form.logo"
                  target="_blank"
                  v-if="isEdited === true && logoBoolean"
                  class="mt-8"
                >
                  show image
                </a>
              </template>
            </section>
          </v-col>
          <v-col sm="6" cols="12" class="align-self-center">
            <h4 class="mb-2">Upload Location Photo</h4>
            <section class="file-upload">
              <new-image-upload
                class="file-upload__image"
                :imgUrl="form.photo ? form.photo.path : ''"
                :imgId="form.photo ? form.photo.id : ''"
                @fileSelected="photoChange"
                fieldName="mainPhotoFile"
                :maxSize="maxSize"
                :reset="resetBoolean"
              />
              <template v-if="form.photo != null">
                <a
                  :href="form.photo"
                  target="_blank"
                  v-if="isEdited === true && photoBoolean"
                  class="mt-8"
                >
                  show image
                </a>
              </template>
            </section>
          </v-col>
          <v-col class="py-2" sm="6" cols="12">
            <form-group name="name" :attribute="`fields.name`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.name"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-2 mx-auto" cols="12" sm="3">
            <form-group name="longitude" :attribute="`fields.longitude`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.longitude"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-2 mx-auto" cols="12" sm="3">
            <form-group name="latitude" :attribute="`fields.latitude`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.latitude"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-0" cols="12" sm="6">
            <form-group name="country" :attribute="`fields.country`">
              <template slot-scope="{ attrs, listeners }">
                <v-select
                  :loading="loadingData"
                  :items="countries"
                  label="Countries"
                  item-text="name"
                  item-value="id"
                  regular
                  clearable
                  return-object
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.country"
                  @change="selectedCountryChange"
                ></v-select>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-0" cols="12" sm="6">
            <form-group name="governorate" attribute="fields.governorate">
              <template slot-scope="{ attrs, listeners }">
                <v-select
                  :loading="loadingData"
                  :items="governorates"
                  :disabled="governorates.length == 0"
                  item-text="name"
                  item-value="id"
                  regular
                  clearable
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.governorate.id"
                ></v-select>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12">
            <v-textarea
              label="Description"
              regular
              v-model.trim="form.description"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-btn
              class="success text-capitalize"
              large
              type="submit"
              width="30%"
              :disabled="$v.form.$invalid"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import {
  IndexData,
  StoreData,
  ShowData,
  UpdateData
} from "@/helpers/apiMethods";
import {
  required,
  decimal,
  minValue,
  maxValue,
  maxLength
} from "vuelidate/lib/validators";
export default {
  data() {
    return {
      busLocations: [],
      form: {
        name: "",
        latitude: "",
        country: {},
        governorate: {
          id: "",
          name: ""
        },
        photo: "",
        logo: ""
      },
      maxSize: 2.048,
      resetLogo: false,
      Logo: false,
      Photo: false,
      stopTime: false,
      returnTime: false,
      isEdited: false,
      loadingData: false,
      globalServerErrors: null,
      countries: [],
      logoBoolean: true,
      photoBoolean: true,
      resetBoolean: false,
      logoChange: false,
      photoChangeBoolean: false
    };
  },
  computed: {
    governorates() {
      if (this.form.country !== "") {
        const country = this.form.country;
        let governorates = [];
        if (this.countries.length !== 0) {
          this.countries.find(item => {
            if (item.id === country.id) {
              governorates = item.governorates;
            }
          });
        }
        return governorates;
      } else {
        return [];
      }
    }
  },
  created() {
    this.editCreateBoolean();
    this.indexBusLocations();
    this.indexCountries();
  },
  methods: {
    indexBusLocations() {
      IndexData({ reqName: "bus-locations" })
        .then(res => {
          const { data } = res.data;
          this.busLocations = data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {});
    },
    indexCountries() {
      IndexData({ reqName: `/countries` })
        .then(res => {
          const { data } = res.data;
          this.countries = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    handleSave() {
      if (!this.isEdited) {
        this.createLocation();
      } else {
        this.editBusStop();
      }
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    showData(id) {
      ShowData({
        reqName: `locations`,
        id: id
      })
        .then(res => {
          const { location } = res.data;
          this.form = location;
        })
        .catch(() => {});
    },
    createLocation() {
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        if (formItem === "country" || formItem === "governorate") {
          formData.append(formItem, this.form[formItem].id);
        } else {
          formData.append(formItem, this.form[formItem]);
          console.log(this.form[formItem]);
        }
      });
      StoreData({
        reqName: `locations`,
        data: formData
      })
        .then(() => {
          this.$router.push("/camp-locations");
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    editBusStop() {
      const formData = new FormData();
      if (!this.logoChange) {
        delete this.form.logo;
      }
      if (!this.photoChangeBoolean) {
        delete this.form.photo;
      }
      Object.keys(this.form).forEach(formItem => {
        console.log(typeof this.form[formItem], formItem);

        if (formItem === "country" || formItem === "governorate") {
          formData.append(formItem, this.form[formItem].id);
        } else {
          if (this.form[formItem] != null) {
            formData.append(formItem, this.form[formItem]);
          }
        }
      });
      // if (this.form.photo == null) {
      //   formData.append(this.form.photo, "");
      // }
      formData.append("_method", "put");
      UpdateData({
        reqName: `locations`,
        data: formData,
        id: this.$route.params.id
      })
        .then(() => {
          this.isEdited = false;
          this.$router.push("/camp-locations");

          this.reset();
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      this.$store.dispatch("ClearServerErrors");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    selectedCountryChange() {
      this.form.governorate.id = "";
    },
    profileChange(photo) {
      this.form.logo = photo.file;
      this.logoBoolean = false;
      this.resetBoolean = false;
      this.logoChange = true;
    },
    photoChange(photo) {
      this.form.photo = photo.file;
      this.photoBoolean = false;
      this.resetBoolean = false;
      this.photoChangeBoolean = true;
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "campLocationEdit") {
          this.$nextTick(() => {
            this.showData(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(190)
      },
      country: {
        required
      },
      governorate: {
        required
      },
      latitude: {
        decimal,
        minValue: minValue(-90),
        maxValue: maxValue(90)
      },
      longitude: {
        decimal,
        minValue: minValue(-180),
        maxValue: maxValue(180)
      }
    }
  }
};
</script>
